<template>
    <div class="ma-0 d-inline-flex" style="align-items: center">
        <v-tooltip top color="white" class="ma-0 pa-0">
            <template v-slot:activator="{ on, attrs }">
                <v-btn icon small v-bind="attrs" v-on="on" @click.stop="lancarEventoBuscarItensFornecedor">
                    <v-icon size="15">format_list_bulleted</v-icon>
                </v-btn>
            </template>
            <span class="py-2">Exibir detalhamento dos itens selecionado pelo Fornecedor.</span>
        </v-tooltip>

        <span class="ma-0 pa-0"> {{ textoItensParticipacao }} </span>

        <v-dialog v-model="mostrarDailodDetalheItens" width="900">
            <v-card>
                <v-card-title class="primary modal-title py-0" primary-title style="height: 50px;">
                    Detalhamento de itens
                </v-card-title>
                <v-card-text>
                    <v-layout>
                        <v-flex xs12 sm3>
                            <strong class="primary--text">Classificação</strong> <br/>
                            <span class="blue-grey--text text-darken-2">{{classificacao || '--'}}</span>
                        </v-flex>
                        <v-flex xs12 sm9>
                            <strong class="primary--text">Participante</strong><br/>
                            <span class="blue-grey--text text-darken-2">{{fornecedor.razaoSocial}} - {{fornecedor.cpfCnpj}}</span>
                        </v-flex>
                    </v-layout>
                </v-card-text>

                <v-card-text>
                    <v-data-table
                        :headers="headers"
                        item-key="id"
                        :items="itensFornecedor.itens"
                        :loading="loading"
                        class="elevation-1">
                        <template v-slot:items="props">
                            <td class="text-xs-left">{{ props.item.descricaoSequencia }}</td>
                            <td class="text-xs-left">{{ props.item.descricao | clipTextFrom(50) }}
                                <ver-mais-tooltip v-if="props.item.descricao && props.item.descricao.length > 50" :descricao="props.item.descricao"/>
                            </td>
                            <td class="text-xs-left">
                                <formatador-moeda :valor="props.item.quantidade" :casas-decimais="casasDecimais"/>
                            </td>
                            <td class="text-xs-left">
                                R$ <formatador-moeda :valor="props.item.valorUnitario" :casas-decimais="casasDecimais"/>
                            </td>
                            <td class="text-xs-left">
                                R$ <formatador-moeda :valor="props.item.valorTotal" :casas-decimais="casasDecimais"/>
                            </td>
                        </template>
                        <template v-slot:footer>
                            <tr class="text-xs-right mt-2 justify-end align-right">
                                <td colspan="5">
                                    <strong class="primary--text mr-1"> Total Geral: </strong>
                                    <span class="blue-grey--text text-darken-2">{{ valorTotalGeralItens | formatarNumero('R$ ', casasDecimais)}}</span>
                                </td>
                            </tr>
                        </template>
                    </v-data-table>
                </v-card-text>

                <v-divider></v-divider>

                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="primary" flat @click="mostrarDailodDetalheItens = false">
                        Voltar
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
import FormatadorMoeda from "@/commons/components/FormatadorMoeda.vue";
import VerMaisTooltip from "@/views/credenciamento/detalhe-credenciamento/orgao/components/VerMaisTooltip.vue";

export default {
    name: "DetalheItensFornecedor",
    components: {VerMaisTooltip, FormatadorMoeda},
    props: ['fornecedor', 'classificacao', 'itensFornecedor', 'casasDecimais', 'loading', 'quantidadeItensCredenciamento', 'numeroItensFornecedor'],
    data: () => {
        return {
            mostrarDailodDetalheItens: false,
            headers: [
                {
                    text: 'Desc. Seq.',
                    align: 'left',
                    sortable: false,
                    value: 'descricaoSequencia',
                    width: '80px',
                    class: 'primary--text'
                },
                {
                    text: 'Descrição',
                    value: 'descricaso',
                    sortable: false,
                    align: 'left',
                    class: 'primary--text'
                },
                {
                    text: 'Quantidade',
                    value: 'quantidade',
                    sortable: false,
                    align: 'left',
                    width: '80px',
                    class: 'primary--text'
                },
                {
                    text: 'Unitário(R$)',
                    value: 'valorUnitario',
                    sortable: false,
                    align: 'left',
                    width: '150px',
                    class: 'primary--text'
                },
                {
                    text: 'Total(R$)',
                    value: 'valorTotal',
                    sortable: false,
                    align: 'left',
                    width: '150px',
                    class: 'primary--text'
                }
            ],
        }
    },
    computed: {
        valorTotalGeralItens() {
            return this.itensFornecedor.totalGeral
        },
        textoItensParticipacao(){
            if(this.numeroItensFornecedor !== this.quantidadeItensCredenciamento)
                return `${this.numeroItensFornecedor} de ${this.quantidadeItensCredenciamento}`
            return 'Todos'
        }
    },
    methods: {
        lancarEventoBuscarItensFornecedor(){
            this.$emit('buscarItens')
            this.mostrarDailodDetalheItens = true
        }
    }
}
</script>

<style scoped lang="stylus">

</style>